// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"4a6f8440","990":"e2d6e06c"}[chunkId] + ".chunk.js";
};